<section>
    <div class="title">
        <h2 class="unl-plan-type" [ngClass]="{ 'plan-seven-unl-plan-type': showPlanUpgradeBanner }">{{
            pageData.selectionPage.planName | lowercase }}</h2>
    </div>
    <xm-switch-banner
        *ngIf="showPlanUpgradeBanner"
        [imageOptions]="circleDeviceIcon"
        [header]="seg5BtgToUnlSwitchBanner.header"
        [description]="seg5BtgToUnlSwitchBanner.description">
    </xm-switch-banner>
    <xm-switch-banner
        *ngIf="showSegmentUpgradeBanner && segmentSwitchBanner"
        [imageOptions]="segmentSwitchIcon"
        [header]="segmentSwitchBanner?.header"
        [description]="segmentSwitchBanner?.body"
        [cta]="segmentSwitchBanner?.cta">
    </xm-switch-banner>
    <div class="content">
        <div class="header">{{ pageData.selectionPage.header }}</div>
        <div class="description">{{ pageData.selectionPage.body }}</div>

        <!-- Displaying promo container temp. Needs to be replaced post CEUIDSS-29611 & CEUIDSS-29620 completion -->
        <div class="promotion-container" *ngIf="promotionData.length > 0 && !isIcopPlanSwitch">
            <div class="multiple-promotions">
                <xm-media-image [imageOptions]="promoIcon" class="promotion-dollar-icon"></xm-media-image>
                <div>
                    <p>{{promotionHeader}}</p>
                    <ul class="promotions-list">
                        <li class="promotions-desc" *ngFor="let data of promotionData">{{ data }}</li>
                    </ul>
                </div>
            </div>
        </div>

        <div *ngIf="(allpromotionContent && isIcopPlanSwitch) || isSeg6ResiUser || isCBMGeminiEnabled"  class="icop-promotions-center">
                <div *ngFor="let promo of allpromotionContent" [ngClass]="promo.type === 'notification' ? 'notification-banner' : 'multiple-promotions'">
                    <xm-media-image [imageOptions]="getPromoIcon(promo.icon)" class="promotion-dollar-icon"></xm-media-image>
                    <div class="notification-content">
                        <p>{{promo.header}}</p>
                        <ul class="promotions-switch-list">
                            <li class="promotions-desc" *ngFor="let data of promo.promotionContent">{{ data }}</li>
                        </ul>
                    </div>
                </div>
        </div>

        <div class="plan-tiers">
            <div class="plan-selector" *ngFor="let planCard of pageData.selectionPage.planCards">
                <xm-radio xmRadioControl class="tier" name="planGroup" [value]="setRadioData(planCard).value"
                    [option]="setRadioData(planCard)" (onSelect)="tierSelect($event)">
                    <div class="wrapper">
                        <div class="left-section">
                            <span class="tier-name">{{ planCard.name }}</span>
                            <p *ngIf="!(showInUseBadge(planCard) || showScheduledBadge(planCard))" class="tier-name">{{
                                planCard.price }}</p>
                            <div *ngIf="showInUseBadge(planCard)" class="badge" role="status"
                                [attr.aria-label]="planCard.name + ' is ' + inUse">
                                <xm-media-image [imageOptions]="inUseIcon" class="badge-icon" center="auto" size="auto">
                                </xm-media-image>
                                <span class="badge-text">{{ planCard.badge }}</span>
                            </div>
                            <div *ngIf="showScheduledBadge(planCard)" class="badge" role="status"
                                [attr.aria-label]="planCard.name + ' is ' + scheduled">
                                <xm-media-image [imageOptions]="scheduledIcon" class="badge-icon schedule-icon"
                                    center="auto" size="auto">
                                </xm-media-image>
                                <span class="badge-text">{{ planCard.badge }}</span>
                            </div>
                        </div>

                        <div class="vertical-divider"></div>

                        <ul class="right-section">
                            <li *ngFor="let point of planCard.points">{{ point }}</li>
                        </ul>
                    </div>
                </xm-radio>
            </div>
        </div>
        <div class="disclaimer">
            <span>{{ pageData.selectionPage.footer }}</span>
        </div>
    </div>
    <div class="buttons">
        <button class="xm-btn-link-light cancel" (click)="onCancel()">{{ pageData.selectionPage.ctas.cancel }}</button>
        <button class="xm-btn-primary-light" [disabled]="isButtonDisabled" [ngClass]="{ 'disabled': isButtonDisabled }"
            (click)="navToSwitchInProgress()">{{ buttonText }}</button>
    </div>
</section>
